import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {formatTimeStr} from 'hiya-common/src/utils/helper'
import * as interfaces from './interface'

export enum UserStatusEnum {
  主态 = 0,
  客态 = 1,
}
// 获取邀请链接 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132030098
export const get_invite_url = createAsyncThunk(
  'medalTitle/live/activity/get_invite_url',
  async (arg: {type: string}, store: any) => {
    const resp = await http.post<HiyaRes<{url: string}>>(
      '/live/activity/get_invite_url',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)
// 获取用户的称号勋章墙数据 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132028784
export const get_user_title_medal_wall = createAsyncThunk(
  'medalTitle/live/privilege/get_user_title_medal_wall',
  async (arg: {mid: number}, store: any) => {
    const resp = await http.post<HiyaRes<InitialStateType['wall']>>(
      '/live/privilege/get_user_title_medal_wall',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)
// 按分类获取勋章列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132029089
export const get_title_medal_list = createAsyncThunk(
  'medalTitle/live/privilege/get_title_medal_list',
  async (arg: {category: number; mid: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<{list: interfaces.GetUserTitleMedalDetailData[]}>
    >('/live/privilege/get_title_medal_list', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
// 获取用户的单个勋章详情 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132028840
export const get_user_title_medal_detail = createAsyncThunk(
  'medalTitle/live/privilege/get_user_title_medal_detail',
  async (arg: {mid: number; title_medal_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<interfaces.GetUserTitleMedalDetailData>
    >('/live/privilege/get_user_title_medal_detail', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
export const uploadImg = createAsyncThunk(
  'medalTitle/uploadImg',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/misc/upload_img',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 用户解锁称号勋章槽位 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132028804
export const unlock_user_title_medal_slot = createAsyncThunk(
  '/live/privilege/unlock_user_title_medal_slot',
  async (
    arg: {
      slot_id: number
      mid: number
      from: string
    },
    store: any
  ) => {
    const resp = await http.post<HiyaRes<{success: boolean}>>(
      '/live/privilege/unlock_user_title_medal_slot',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  wall?: {
    member?: {
      avatar: string
      mid: number
      name: string
      zy_id: number
    }
    total?: number // 已获得总数.
    wearing?: number // 当前穿戴数量.
    list: interfaces.UserTitleMedalOfWallDTO[]
  }
  title_medal_list?: interfaces.GetUserTitleMedalDetailData[]

  base: {
    isEdit: boolean
    userStatus: UserStatusEnum
    selectedMedals: interfaces.UserTitleMedalOfWallDTO[]
  }
  invite_url?: string
  medalDetail?: interfaces.GetUserTitleMedalDetailData
}

const initialState: InitialStateType = {
  base: {
    isEdit: false,
    userStatus: UserStatusEnum.主态,
    selectedMedals: [],
  },
}

export const MedalTitleSlice = createSlice({
  name: 'MedalTitleSlice',
  initialState,
  reducers: {
    updateSelectedMedals: (
      state,
      action: PayloadAction<interfaces.UserTitleMedalOfWallDTO[]>
    ) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          selectedMedals: action.payload,
        },
      })
    },
    updateEditing: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          isEdit: action.payload,
        },
      })
    },
    updateUserStatus: (state, action: PayloadAction<UserStatusEnum>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          userStatus: action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_user_title_medal_wall.fulfilled, (state, action) => {
      const {base} = state
      // const {wear_medal} = action.payload
      const {list} = action.payload
      Object.assign(state, {
        wall: action.payload,
        base: {...base, selectedMedals: list},
      })
    })

    builder.addCase(get_title_medal_list.fulfilled, (state, action) => {
      // const {wear_medal} = action.payload
      const {list} = action.payload
      Object.assign(state, {
        title_medal_list: list?.map((item) => ({
          ...item,
          animation_h5: item.animation_h5 || item.icon,
          et_str: item.et ? formatTimeStr(item.et * 1000, 'YYYY/MM/DD') : '',
        })),
      })
    })
    builder.addCase(get_invite_url.fulfilled, (state, action) => {
      Object.assign(state, {invite_url: action.payload.url})
    })
    builder.addCase(get_user_title_medal_detail.fulfilled, (state, action) => {
      Object.assign(state, {
        medalDetail: {
          ...action.payload,
          et_str: action.payload.et
            ? formatTimeStr(action.payload.et * 1000, 'YYYY/MM/DD')
            : '',
        },
      })
    })
  },
})
export default MedalTitleSlice.reducer
export const MedalTitleActions = MedalTitleSlice.actions

export const useMedalTitleState = () => {
  const data = useSelector((state) => {
    return state.MedalTitle
  })
  return data
}
